import { combineReducers } from 'redux';
import courses from './courses';
import users from './users';
import paginator from './paginator';
import items from './items';
import feedrows from './feedrows';
import auth from './auth';
import topologies from './topologies';
import notifications from './notifications';
import quizzes from './quizzes';
import questions from './questions';
import checkout from './checkout';
import others from './others';
import sales from './sales';
import player from './player';
import batches from './batches';
import classroom from './classroom';
import educator from './educator';
import educatorOnboarding from './educatorOnboarding';
import createQuestion from './createQuestion';
import dashboard from './dashboard';
import summit from './summit';
import updates from './updateReducers';
import doubts from './doubts';
import doubtSolutions from './doubtSolutions';
import helpCenter from './helpCenter';
import templates from './templates';
import combats from './combats';
import helper from './helper';
import drive from './drive';
import ttu from './ttu';
import currentPageInfo from './currentPageInfo';
import practiceSession from './practiceSession';

export default combineReducers({
  courses,
  combats,
  users,
  paginator,
  topologies,
  items,
  auth,
  feedrows,
  notifications,
  quizzes,
  questions,
  checkout,
  others,
  sales,
  player,
  batches,
  classroom,
  educator,
  educatorOnboarding,
  createQuestion,
  dashboard,
  updates,
  doubts,
  doubtSolutions,
  summit,
  helpCenter,
  templates,
  helper,
  drive,
  ttu,
  currentPageInfo,
  practiceSession
});
